import { render, staticRenderFns } from "./PublicStorage.vue?vue&type=template&id=ad6752da&lang=pug"
import script from "./PublicStorage.vue?vue&type=script&lang=js"
export * from "./PublicStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports